/// <reference path="../../../../typings/index.d.ts" />
///<reference path="./short-cuts-list.service.ts"/>
///<reference path="../tracking/trackingItem.ts"/>
///<reference path="../tracking/tracking.interface.ts"/>
///<reference path="../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../baseClasses/dataMaintenanceControllerBase.ts"/>
///<reference path="../common/security.service.ts"/>
///<reference path="../modal/modal.interface.ts"/>
///<reference path="../common/security.parts.ts"/>


module Meevo.Components.ShortCuts {
    import IDataMaintenanceContext = Meevo.Components.BaseClasses.IDataMaintenanceContext;
    import ICombinationNames = Meevo.Components.ShortCuts.ICombinationNames;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    //#endregionImports

    //#regionShortCutsService
    export class ShortCutsService implements IShortCutsService {
        private activeGroups: IShortCutGroup[];

        static factory() {
            const service = (shortKeysListService: IShortCutsListService,
                             trackingService: Meevo.Components.Tracking.ITrackingService,
                             securityService: Meevo.Components.Common.ISecurityService,
                             $q: angular.IQService,
                             hotkeys: angular.hotkeys.HotkeysProvider) => new ShortCutsService(shortKeysListService, trackingService, securityService, $q, hotkeys);

            service.$inject = [
                'meevo.components.short-cuts.ShortCutsListService',
                'meevo.components.tracking.TrackingService',
                'meevo.components.common.SecurityService',
                '$q',
                'hotkeys'
            ];

            return service;
        }

        constructor(private shortKeysListService: IShortCutsListService,
                    private trackingService: Meevo.Components.Tracking.ITrackingService,
                    private securityService: Meevo.Components.Common.ISecurityService,
                    private $q: angular.IQService,
                    private hotkeys: angular.hotkeys.HotkeysProvider) {
            this.activeGroups = [];
        }

        private checkSecure(securityKey: string): ng.IPromise<Model.SecurityItem> {
            if (securityKey) {
                return this.securityService
                    .checkSecurityItem(securityKey)
                    .catch(() => {
                        return null;
                    });
            }

            return this.$q.resolve(null);
        }

        public isIEorEDGE(): boolean {
            return navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape' || navigator.appVersion.indexOf('Edge') > -1;
        }

        /**
         * Method adds the hotkey to the global area and produce it with the middleware function.
         * @example
         * shortKeysService.add('DATA_MAINTENANCE_ADD', (event: Event, hotkey: ng.hotkeys.Hotkey) => {
         *     // Do something there on callback
         * })
         * @example
         * shortKeysService.add('DATA_MAINTENANCE_DELETE', (event: Event, hotkey: ng.hotkeys.Hotkey) => {
         *     // Do something there on callback
         * }, $scope);
         * @param keyName
         * @param callback
         * @param options
         */
        public add(keyName: keyof ICombinationNames, callback: TShortCutCallback, options?: IAddShortCutOptions): IShortCutsService {
            const {noun, scope, securityKey} = options;
            const combo: IShortCutCombination = this.shortKeysListService.get(keyName);
            const hickeys = scope ? this.hotkeys.bindTo(scope) : this.hotkeys;
            let lastEvent: Event = null;

            this.checkSecure(securityKey || combo.securityKey)
                .then((securityItem) => {
                    if (securityItem && securityItem.securityAccess === SecurityAccessEnum.Hide) {
                        return;
                    }

                    hickeys
                        .add({
                            combo: combo.combination,
                            description: combo.description,
                            allowIn: combo.allowIn,
                            callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                                event.preventDefault();

                                // show error message if access is Deny
                                if (securityItem && securityItem.securityAccess === SecurityAccessEnum.Deny) {
                                    this.securityService.showDenyWarning(securityItem.securityKeyPath, securityKey || combo.securityKey);

                                    return;
                                }

                                // don't keep calling UsageTracking when keys are held down as javascript events keeps firing
                                if (!this.isIEorEDGE()) {
                                    if (event['repeat'] === true) {
                                        return;
                                    }
                                } else {
                                    // ie fallback
                                    const lastEventTimeStamp = lastEvent ? angular.copy(lastEvent.timeStamp) : 0;
                                    lastEvent = event;
                                    // if the events are less then a second apart
                                    if (event.timeStamp - lastEventTimeStamp < 1000) {
                                        return;
                                    }
                                }

                                if (noun || combo.noun) {
                                    // UsageTracking
                                    const trackingItem = new Meevo.Model.TrackingItem(noun || combo.noun, Meevo.Model.VerbEnum.KeyboardShortcutPressed, {combo: hotkey.combo});
                                    this.trackingService.saveTrackingInfo(trackingItem);
                                }

                                callback(event, hotkey);
                            }
                        });
                });

            return this;
        }

        public del(combinationNames: keyof ICombinationNames | (keyof ICombinationNames)[]): void {
            if (typeof combinationNames === 'string') {
                combinationNames = [combinationNames];
            }

            this.hotkeys.del(this.shortKeysListService.getHotKeys(combinationNames));
        }

        public getGroupByIndex(index: GroupLevels): IShortCutGroup | null {
            return this.activeGroups[index];
        }

        /**
         * Method activates a group of short keys and deactivates the other groups on the other levels.
         * @param {Meevo.Components.ShortCuts.IShortCutGroup} group
         * @param noun
         * @param hard
         */
        public activateGroup(group: IShortCutGroup, noun?: Meevo.Model.NounEnum, hard: boolean = true) {
            if (!group) return;

            if (hard) {
                // we have a cases when we have to deactivate the global shortcuts like modal/menu/etc
                this.deactivateGroups(group.deactivateGlobal ? GroupLevels.Global : GroupLevels.Plugin);

                this.activeGroups = this.activeGroups.slice(0, group.groupLevel);
            }

            if (noun) {
                group.noun = noun;
            }

            if (!hard && this.activeGroups.length > group.groupLevel + 1) {
                if (this.activeGroups[group.groupLevel]) {
                    this.del(this.activeGroups[group.groupLevel].shortCutCombinationNames);
                }
                this.activeGroups[group.groupLevel] = group;

                return this;
            }

            group.shortCuts
                .forEach((combinationName) => {
                    this.add(combinationName.shortCutName, combinationName.callback, {
                        scope: group.scope,
                        noun: group.noun,
                        securityKey: combinationName.securityKey
                    });
                });

            this.activeGroups[group.groupLevel] = group;

            return this;
        }

        /**
         * method deactivate a group of short keys
         * @param {Meevo.Components.ShortCuts.IShortCutGroup} group
         */
        public deactivateGroup(group: IShortCutGroup) {
            if (!group) return;
            // if group id is not the same as the current active group id
            // we do nothing because we already deactivate this group
            if (this.activeGroups[group.groupLevel] && group.id !== this.activeGroups[group.groupLevel].id) {
                return this;
            }

            this.deactivateGroups();

            this.activeGroups = this.activeGroups.slice(0, group.groupLevel);

            this.activateGroups();

            return this;
        }

        /**
         * Activates all existing groups
         */
        public activateGroups() {
            this.activeGroups
                .forEach((group) => {
                    if (group) {
                        this.activateGroup(group);
                    }
                });
        }

        /**
         * method deactivate all active groups of short keys
         */
        public deactivateGroups(startLevel: GroupLevels = GroupLevels.Plugin) {
            this.activeGroups
                .slice(startLevel)
                .forEach((group) => {
                    this.del(group.shortCutCombinationNames);
                });

            return this;
        }

        public contextMethodsWrapper<Context extends { preventUsageTracking?: boolean; }, Controller extends { getContext?(): Context; context?: Context; }>(controller: Controller, fnName: keyof Context): TShortCutCallback {

            return (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                let context: Context;

                if (controller.hasOwnProperty('getContext')) {
                    context = controller.getContext();
                } else {
                    context = controller.context;
                }

                if (typeof context[fnName] === 'function') {
                    context.preventUsageTracking = true;
                    (<any>context[fnName]).call(context);
                    context.preventUsageTracking = false;
                }
            };
        }

        public maintenanceFormDirectiveWrapper(scope: IMaintenencaFormWrapreScope): void {
            if (scope.shortCutGroup instanceof ShortCutGroup) {
                scope.shortCutGroup.removeShortCuts([
                    'DATA_MAINTENANCE_SAVE', 
                    'DATA_MAINTENANCE_CANCEL'
                ]);
                scope.shortCutGroup.addShortCuts({
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        scope.context.preventUsageTracking = true;
                        scope.submitForm();
                        scope.context.preventUsageTracking = false;
                    }
                });
                scope.shortCutGroup.addShortCuts({
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: this.contextMethodsWrapper<IDataMaintenanceContext, any>(scope, 'cancel')
                });
            } else {
                const SaveShortCutGroup = new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        scope.context.preventUsageTracking = true;
                        scope.submitForm();
                        scope.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: this.contextMethodsWrapper<IDataMaintenanceContext, any>(scope, 'cancel')
                }]);

                scope.shortCutGroup[MaintenanceFormState.Adding] = SaveShortCutGroup;
                scope.shortCutGroup[MaintenanceFormState.Editing] = SaveShortCutGroup;
                scope.shortCutGroup[MaintenanceFormState.Copying] = SaveShortCutGroup;
            }
        }
    }

    //#endregionShortCutsService

    angular.module('meevo.components.short-cuts')
        .factory('meevo.components.short-cuts.ShortCutsService', ShortCutsService.factory());
}
